import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";

export const getUserFullNameFromEmail = (users, email) => {
  if (isEmpty(users) || !isArray(users)) {
    return null;
  }
  const user = users.find((user) => user.emailAddress === email);
  return user ? user.fullName : email;
};
